export const isRunningCypress = () =>
  typeof window !== 'undefined' &&
  (navigator.userAgent.includes('Cypress') || Boolean((window as any).Cypress));
